import React, { useEffect, useState } from "react";
import styles from "./campaigns.page.module.scss";

const statCards = [
  { label: "Total Campaigns", value: "3", tone: "default" },
  { label: "Active", value: "3", tone: "active" },
  { label: "Total Recordings", value: "8", tone: "info" },
  { label: "Unique Enumerators", value: "4", tone: "accent" },
];

const campaigns = [
  {
    code: "LAG001",
    status: "ended",
    title: "Calamba Area Pulse Check",
    date: "April 13, 2026",
    location: "Calamba & Binan, Laguna",
    enumerators: "2",
    recordings: "4",
    details: {
      totalRecordings: 4,
      enumeratorPerformance: [
        { name: "Juan dela Cruz", initials: "JdC", count: 3 },
        { name: "Ana Reyes", initials: "AR", count: 1 },
      ],
      ageDistribution: [
        { label: "18-30", count: 1 },
        { label: "31-45", count: 2 },
        { label: "46-60", count: 1 },
      ],
      genderDistribution: [
        { label: "Male", count: 0 },
        { label: "Female", count: 4 },
      ],
    },
  },
  {
    code: "LAG002",
    status: "active",
    title: "Industrial Zone Survey",
    date: "April 13, 2026",
    location: "Cabuyao & Santa Rosa, Laguna",
    enumerators: "1",
    recordings: "2",
    details: {
      totalRecordings: 2,
      enumeratorPerformance: [{ name: "Miguel Santos", initials: "MS", count: 2 }],
      ageDistribution: [
        { label: "18-30", count: 1 },
        { label: "31-45", count: 1 },
        { label: "46-60", count: 0 },
      ],
      genderDistribution: [
        { label: "Male", count: 1 },
        { label: "Female", count: 1 },
      ],
    },
  },
  {
    code: "LAG003",
    status: "active",
    title: "South Laguna Sentiment",
    date: "April 14, 2026",
    location: "Los Banos & San Pablo, Laguna",
    enumerators: "2",
    recordings: "2",
    details: {
      totalRecordings: 2,
      enumeratorPerformance: [
        { name: "Lea Ramos", initials: "LR", count: 1 },
        { name: "Noel Diaz", initials: "ND", count: 1 },
      ],
      ageDistribution: [
        { label: "18-30", count: 0 },
        { label: "31-45", count: 1 },
        { label: "46-60", count: 1 },
      ],
      genderDistribution: [
        { label: "Male", count: 1 },
        { label: "Female", count: 1 },
      ],
    },
  },
];

const CampaignsPage = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isEndCampaignModalOpen, setIsEndCampaignModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [campaignToEnd, setCampaignToEnd] = useState(null);
  const [campaignForm, setCampaignForm] = useState({
    code: "",
    name: "",
    date: "",
    location: "",
  });

  useEffect(() => {
    if (!isCreateModalOpen && !isDetailsModalOpen && !isEndCampaignModalOpen) {
      return undefined;
    }

    const onEscClose = (event) => {
      if (event.key === "Escape") {
        setIsCreateModalOpen(false);
        setIsDetailsModalOpen(false);
        setIsEndCampaignModalOpen(false);
      }
    };

    window.addEventListener("keydown", onEscClose);

    return () => {
      window.removeEventListener("keydown", onEscClose);
    };
  }, [isCreateModalOpen, isDetailsModalOpen, isEndCampaignModalOpen]);

  const onOpenCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const onCloseCreateModal = () => {
    setIsCreateModalOpen(false);
  };

  const onCampaignFormChange = (event) => {
    const { id, value } = event.target;
    setCampaignForm((previous) => ({
      ...previous,
      [id]: id === "code" ? value.toUpperCase() : value,
    }));
  };

  const onCreateCampaign = (event) => {
    event.preventDefault();
    setIsCreateModalOpen(false);
  };

  const onOpenDetailsModal = (campaign) => {
    setSelectedCampaign(campaign);
    setIsDetailsModalOpen(true);
  };

  const onCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedCampaign(null);
  };

  const getPercent = (count, total) => {
    if (!total) {
      return 0;
    }

    return Math.round((count / total) * 100);
  };

  const onOpenEndCampaignModal = (campaign) => {
    setCampaignToEnd(campaign);
    setIsEndCampaignModalOpen(true);
  };

  const onCloseEndCampaignModal = () => {
    setIsEndCampaignModalOpen(false);
    setCampaignToEnd(null);
  };

  const onConfirmEndCampaign = () => {
    setIsEndCampaignModalOpen(false);
    setCampaignToEnd(null);
  };

  return (
    <div className={styles.page}>
      <div className={styles.headerRow}>
        <div>
          <h1>Campaign Manager</h1>
          <p>Create and manage survey campaign codes</p>
        </div>
        <button className={styles.createButton} type="button" onClick={onOpenCreateModal}>
          <span aria-hidden="true">+</span>
          Create Campaign
        </button>
      </div>

      <section className={styles.statsGrid}>
        {statCards.map((card) => (
          <article key={card.label} className={styles.statCard}>
            <p>{card.label}</p>
            <strong className={styles[card.tone]}>{card.value}</strong>
          </article>
        ))}
      </section>

      <section className={styles.campaignList}>
        {campaigns.map((campaign) => {
          if (campaign.status === "ended") {
            return (
              <article key={campaign.code} className={styles.campaignCardEnded}>
                <div className={styles.cardEndedTop}>
                  <div className={styles.cardIdentity}>
                    <div className={styles.codeBadge}>
                      <span className={styles.codeBadgeText}>{campaign.code}</span>
                    </div>
                    <span className={styles.statusBadge}>ended</span>
                  </div>
                </div>

                <h3 className={styles.cardTitle}>{campaign.title}</h3>

                <div className={styles.cardDetailsGrid}>
                  <div className={styles.cardDetailItem}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={styles.cardIcon}
                      aria-hidden="true"
                    >
                      <path d="M8 2v4" />
                      <path d="M16 2v4" />
                      <rect width="18" height="18" x="3" y="4" rx="2" />
                      <path d="M3 10h18" />
                    </svg>
                    <div>
                      <p className={styles.cardItemLabel}>Date</p>
                      <p className={styles.cardItemValue}>{campaign.date}</p>
                    </div>
                  </div>

                  <div className={styles.cardDetailItem}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={styles.cardIcon}
                      aria-hidden="true"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    <div>
                      <p className={styles.cardItemLabel}>Location</p>
                      <p className={styles.cardItemValue}>{campaign.location}</p>
                    </div>
                  </div>

                  <div className={styles.cardDetailItem}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={styles.cardIcon}
                      aria-hidden="true"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div>
                      <p className={styles.cardItemLabel}>Enumerators</p>
                      <p className={styles.cardItemValue}>{campaign.enumerators}</p>
                    </div>
                  </div>

                  <div className={styles.cardDetailItem}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={styles.cardIcon}
                      aria-hidden="true"
                    >
                      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
                      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                      <line x1="12" x2="12" y1="19" y2="22" />
                    </svg>
                    <div>
                      <p className={styles.cardItemLabel}>Recordings</p>
                      <p className={styles.cardItemValue}>{campaign.recordings}</p>
                    </div>
                  </div>
                </div>

                <div className={styles.cardEndedActions}>
                  <button
                    type="button"
                    className={styles.detailsButton}
                    onClick={() => onOpenDetailsModal(campaign)}
                  >
                    View Details
                  </button>
                </div>
              </article>
            );
          }

          return (
            <article key={campaign.code} className={styles.campaignCard}>
              <div className={styles.cardTop}>
                <div className={styles.identityRow}>
                  <span className={styles.code}>{campaign.code}</span>
                  <span className={styles.status}>{campaign.status}</span>
                </div>

                <h3>{campaign.title}</h3>

                <div className={styles.metaGrid}>
                  <div>
                    <p className={styles.metaLabel}>Date</p>
                    <p className={styles.metaValue}>{campaign.date}</p>
                  </div>

                  <div>
                    <p className={styles.metaLabel}>Location</p>
                    <p className={styles.metaValue}>{campaign.location}</p>
                  </div>

                  <div>
                    <p className={styles.metaLabel}>Enumerators</p>
                    <p className={styles.metaValue}>{campaign.enumerators}</p>
                  </div>

                  <div>
                    <p className={styles.metaLabel}>Recordings</p>
                    <p className={styles.recordingValue}>{campaign.recordings}</p>
                  </div>
                </div>
              </div>

              <div className={styles.actions}>
                <button
                  type="button"
                  className={styles.endButton}
                  onClick={() => onOpenEndCampaignModal(campaign)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={styles.stopIcon}
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <rect x="9" y="9" width="6" height="6" rx="1" />
                  </svg>
                  End Campaign
                </button>
                <button
                  type="button"
                  className={styles.detailsButton}
                  onClick={() => onOpenDetailsModal(campaign)}
                >
                  View Details
                </button>
              </div>
            </article>
          );
        })}
      </section>

      {isEndCampaignModalOpen && campaignToEnd && (
        <div className={styles.modalRoot} role="presentation" onMouseDown={onCloseEndCampaignModal}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="end-campaign-title"
            aria-describedby="end-campaign-description"
            className={styles.modalContent}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2 id="end-campaign-title">End Campaign</h2>
            </div>

            <div className={styles.endCampaignBody}>
              <p id="end-campaign-description" className={styles.endCampaignMessage}>
                Are you sure you want to end the campaign{" "}
                <span className={styles.campaignNameHighlight}>{`"${campaignToEnd.title}"`}</span>?
              </p>

              <div className={styles.warningBox}>
                <p className={styles.warningText}>
                  This will mark the campaign as ended. No new recordings can be submitted under
                  this campaign code.
                </p>
              </div>

              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.cancelButton}
                  onClick={onCloseEndCampaignModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={styles.endConfirmButton}
                  onClick={onConfirmEndCampaign}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={styles.endIconSmall}
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <rect x="9" y="9" width="6" height="6" rx="1" />
                  </svg>
                  End Campaign
                </button>
              </div>
            </div>

            <button type="button" className={styles.closeButton} onClick={onCloseEndCampaignModal}>
              <span aria-hidden="true">x</span>
              <span className={styles.srOnly}>Close</span>
            </button>
          </div>
        </div>
      )}

      {isDetailsModalOpen && selectedCampaign && (
        <div className={styles.modalRoot} role="presentation" onMouseDown={onCloseDetailsModal}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="campaign-details-title"
            aria-describedby="campaign-details-description"
            className={styles.detailsModalContent}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className={styles.detailsModalScroll}>
              <div className={styles.modalHeader}>
                <div className={styles.detailsHeaderRow}>
                  <div className={styles.detailsIdentity}>
                    <h2 id="campaign-details-title">{selectedCampaign.title}</h2>
                    <p id="campaign-details-description" className={styles.srOnly}>
                      Campaign summary with recordings, enumerator performance, and demographic
                      distribution.
                    </p>
                    <div className={styles.identityRow}>
                      <span className={styles.detailsCodeBadge}>{selectedCampaign.code}</span>
                      <span className={styles.detailsStatusBadge}>{selectedCampaign.status}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.detailsBody}>
                <div className={styles.detailsMiniGrid}>
                  <div className={styles.detailsPanel}>
                    <p className={styles.detailsPanelLabel}>Campaign Date</p>
                    <p className={styles.detailsPanelValue}>{selectedCampaign.date}</p>
                  </div>

                  <div className={styles.detailsPanel}>
                    <p className={styles.detailsPanelLabel}>Location</p>
                    <p className={styles.detailsPanelValue}>{selectedCampaign.location}</p>
                  </div>
                </div>

                <div className={styles.recordingsPanel}>
                  <div className={styles.recordingsValueRow}>
                    <div>
                      <p className={styles.recordingsTitle}>Total Recordings Submitted</p>
                      <p className={styles.recordingsValue}>
                        {selectedCampaign.details.totalRecordings}
                      </p>
                    </div>
                    <div className={styles.micBadge}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={styles.micIcon}
                        aria-hidden="true"
                      >
                        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
                        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                        <line x1="12" x2="12" y1="19" y2="22" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className={styles.detailsPanel}>
                  <h4 className={styles.sectionTitle}>Enumerators Performance</h4>
                  <div className={styles.performanceList}>
                    {selectedCampaign.details.enumeratorPerformance.map((enumerator) => (
                      <div key={enumerator.name} className={styles.performanceRow}>
                        <div className={styles.identityRow}>
                          <span className={styles.avatarChip}>{enumerator.initials}</span>
                          <span className={styles.detailsPanelValue}>{enumerator.name}</span>
                        </div>

                        <div className={styles.performanceMeta}>
                          <div className={styles.performanceBarTrack}>
                            <div
                              className={styles.performanceBarFill}
                              style={{
                                width: `${getPercent(
                                  enumerator.count,
                                  selectedCampaign.details.totalRecordings,
                                )}%`,
                              }}
                            />
                          </div>
                          <span className={styles.performanceCount}>{enumerator.count}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className={styles.splitGrid}>
                  <div className={styles.detailsPanel}>
                    <h4 className={styles.sectionTitle}>Age Distribution</h4>
                    <div className={styles.performanceList}>
                      {selectedCampaign.details.ageDistribution.map((item) => (
                        <div key={item.label} className={styles.distItem}>
                          <span className={styles.distLabel}>{item.label}</span>
                          <div className={styles.performanceMeta}>
                            <div className={styles.distBarTrack}>
                              <div
                                className={styles.distBarFillPurple}
                                style={{
                                  width: `${getPercent(
                                    item.count,
                                    selectedCampaign.details.totalRecordings,
                                  )}%`,
                                }}
                              />
                            </div>
                            <span className={styles.performanceCount}>{item.count}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={styles.detailsPanel}>
                    <h4 className={styles.sectionTitle}>Gender Distribution</h4>
                    <div className={styles.performanceList}>
                      {selectedCampaign.details.genderDistribution.map((item) => (
                        <div key={item.label} className={styles.distItem}>
                          <span className={styles.distLabel}>{item.label}</span>
                          <div className={styles.performanceMeta}>
                            <div className={styles.distBarTrack}>
                              <div
                                className={styles.distBarFillAmber}
                                style={{
                                  width: `${getPercent(
                                    item.count,
                                    selectedCampaign.details.totalRecordings,
                                  )}%`,
                                }}
                              />
                            </div>
                            <span className={styles.performanceCount}>{item.count}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button type="button" className={styles.closeButton} onClick={onCloseDetailsModal}>
              <span aria-hidden="true">x</span>
              <span className={styles.srOnly}>Close</span>
            </button>
          </div>
        </div>
      )}

      {isCreateModalOpen && (
        <div className={styles.modalRoot} role="presentation" onMouseDown={onCloseCreateModal}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="create-campaign-title"
            aria-describedby="create-campaign-description"
            className={styles.modalContent}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2 id="create-campaign-title">Create New Campaign</h2>
              <p id="create-campaign-description" className={styles.srOnly}>
                Fill out campaign code, name, date, and location to create a campaign.
              </p>
            </div>

            <form className={styles.modalBody} onSubmit={onCreateCampaign}>
              <div className={styles.formField}>
                <label htmlFor="code">Campaign Code (6 characters)</label>
                <input
                  id="code"
                  placeholder="e.g. LAG004"
                  maxLength={6}
                  value={campaignForm.code}
                  onChange={onCampaignFormChange}
                  required
                />
              </div>

              <div className={styles.formField}>
                <label htmlFor="name">Campaign Name</label>
                <input
                  id="name"
                  placeholder="e.g. North Laguna Pulse Check"
                  value={campaignForm.name}
                  onChange={onCampaignFormChange}
                  required
                />
              </div>

              <div className={styles.formField}>
                <label htmlFor="date">Campaign Date</label>
                <input
                  type="date"
                  id="date"
                  value={campaignForm.date}
                  onChange={onCampaignFormChange}
                  required
                />
              </div>

              <div className={styles.formField}>
                <label htmlFor="location">Location</label>
                <input
                  id="location"
                  placeholder="e.g. Calamba and Binan, Laguna"
                  value={campaignForm.location}
                  onChange={onCampaignFormChange}
                  required
                />
              </div>

              <div className={styles.modalActions}>
                <button type="button" className={styles.cancelButton} onClick={onCloseCreateModal}>
                  Cancel
                </button>
                <button type="submit" className={styles.submitButton}>
                  Create Campaign
                </button>
              </div>
            </form>

            <button type="button" className={styles.closeButton} onClick={onCloseCreateModal}>
              <span aria-hidden="true">x</span>
              <span className={styles.srOnly}>Close</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignsPage;
